module.exports = __webpack_public_path__ + "img/1020_sp.5eee1d1f.gif";